import { useEffect } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';

const DesktopProfileLayout: React.FC = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  useEffect(() => {
    navigate('details');
  }, [pathname]);

  return <Outlet />;
};

export default DesktopProfileLayout;
